import type {
  AttendRegisterEntity,
} from './entity/attendRegisterEntity';
import type { AttendRegisterIRepository } from './entity/attendRegisterIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

const getDateMonthKey = (year: number, month: number): string => {
  const m = (`00${month}`).slice(-2);
  return `${year}-${m}`;
};

/**
 * AttendRegisterDomainService
 */
export class AttendRegisterDomainService extends DomainServiceBase {
  private attendRegisterRepository!: AttendRegisterIRepository;

  /**
   * Injection
   * @param attendRegisterRepository attendRegisterRepository
   */
  public inject(
    attendRegisterRepository: AttendRegisterIRepository,
  ) {
    this.attendRegisterRepository = attendRegisterRepository;
  }

  /**
   * getAttendRegisterMonthList
   * @param year 年
   * @param month 月
   * @param parentChildId parentChildId
   * @param token token
   * @returns アイテムリスト
   */
  async getAttendRegisterMonthList(
    year: number,
    month: number,
    parentChildId: string,
    token: string | null,
  ) {
    const key: string = getDateMonthKey(year, month);
    const result = await this.attendRegisterRepository.getListWithSubKey(
      `${parentChildId}#${key}`,
      token,
    );
    const items = result.items.map((v: AttendRegisterEntity) => v.toJson());
    return items;
  }
}
